<script lang="tsx">
import { defineComponent, reactive, toRefs } from 'vue'

import { Node } from '@antv/x6'

const props = {
  node: {
    type: Node,
    default: () => ({})
  }
}

export default defineComponent({
  name: 'FlowDialog',
  props,
  setup(props) {
    const { node } = props
    let flowData = reactive({ current: node.getData() })
    const { current } = toRefs(flowData)

    return () => (
      <div class="flow_wrap">
        这是详情
        <span>{current.value?.name}</span>
      </div>
    )
  }
})
</script>
<style scoped lang="scss">
.flow_wrap {
  display: flex;
  width: 400px;
  min-height: 200px;
  overflow-y: auto;
  flex-shrink: 0;
  border-radius: 5px;
  background: #fff;
  border: 1px solid transparent;
  box-sizing: border-box;
  padding: 10px;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.12);
}
</style>
